import Service from "@ember/service"
import { tracked } from "tracked-built-ins"

export default class BasicTooltip extends Service {
  @tracked isVisible = false
  @tracked targetId = null
  @tracked message = null

  show({ targetId, message }) {
    this.isVisible = true
    this.targetId = targetId
    this.message = message
  }

  hide({ targetId }) {
    this.isVisible = false
  }
}
